import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { IExpertiseRequestBody, IExpertiseResponse } from './expertise.interface';

import { axiosApiInstance } from 'services/config';
import { IExpertise, IExpertiseIndustry } from 'types/domain/expertise';
import { convertExpertiseToDetailsView } from 'utils';

class ExpertiseApi {
  async getAllExpertisesByOrgId(
    organizationId: number,
    config?: AxiosRequestConfig,
  ): Promise<IExpertise[]> {
    const response: AxiosResponse<IExpertiseResponse[]> = await axiosApiInstance.get(
      `expertise/organization/${organizationId}`,
      config,
    );
    return response.data.map(convertExpertiseToDetailsView);
  }

  async getExpertiseById(
    expertiseId: number,
    config?: AxiosRequestConfig,
  ): Promise<IExpertise> {
    const response: AxiosResponse<IExpertiseResponse> = await axiosApiInstance.get(
      `expertise/${expertiseId}`,
      config,
    );
    return convertExpertiseToDetailsView(response.data);
  }

  async createExpertise(
    expertiseData: IExpertiseRequestBody,
    config?: AxiosRequestConfig,
  ): Promise<IExpertise> {
    const response: AxiosResponse<IExpertiseResponse> = await axiosApiInstance.post(
      'expertise',
      expertiseData,
      config,
    );
    return convertExpertiseToDetailsView(response.data);
  }

  async updateExpertise(
    expertiseId: number,
    expertiseData: IExpertiseRequestBody,
    config?: AxiosRequestConfig,
  ): Promise<IExpertise> {
    const response: AxiosResponse<IExpertiseResponse> = await axiosApiInstance.put(
      `expertise/${expertiseId}`,
      expertiseData,
      config,
    );
    return convertExpertiseToDetailsView(response.data);
  }

  async deleteExpertise(expertiseId: number): Promise<void> {
    await axiosApiInstance.delete(`expertise/${expertiseId}`);
  }

  async getExpertiseIndustries(
    config?: AxiosRequestConfig,
  ): Promise<IExpertiseIndustry[]> {
    const response = await axiosApiInstance.get('industry', config);
    return response.data.flat();
  }

  async unsubscribeExpertise(id: number): Promise<IExpertise> {
    const response: AxiosResponse<IExpertise> = await axiosApiInstance.patch(
      `expertise/${id}/unsubscribe`,
    );
    return response.data;
  }
}

export { ExpertiseApi };
